import {
    DOCUMENTOS,
    DOCUMENTOS_SUCCESS,
    DOCUMENTOS_FAIL,
    LISTA_DOCUMENTOS,

    DOCUMENTO_ADICIONADO,
    DOCUMENTO_ADICIONADO_FAIL,

    SIG,
    SIG_SUCCESS,
    SIG_FAIL,

    DOC_SELECTED,
    DOC_NOT_SELECTED,

    SIG_CONTATAR_SUCCESS,
    SIG_CONTATAR_FAIL,

    SIG_REMOVE,

    EXIBIR_DOC,
    EXIBIR_DOC_SUCCESS,
    EXIBIR_DOC_FAIL,

    BAIXAR_DOC,

    CHANGE_STATUS,
    CHANGE_STATUS_SUCCESS,
    CHANGE_STATUS_FAIL,

    LIMPA_MSGS,

    EXIBIR_EVIDENCIA,
    EXIBIR_EVIDENCIA_SUCCESS,
    EXIBIR_EVIDENCIA_FAIL,

    AGRUPADOR,
    ADDSTATE
} from '../actions/types'

const INITIAL_STATE = {
    load_doc: false,
    documentos: [],
    paginate: {
        total: 0,
        perPage: 5,
        page: 1,
        lastPage: 1
    },
    documento: undefined,
    error_doc: '',

    sig_msg: '',
    sig_load: false,
    sig_error: false,

    sig_remove_load: false,
    sig_remove_msg: '',

    exibir_doc: undefined,
    exibir_doc_load: false,

    load_change_status: false,
    change_status_msg: '',
    change_status_error: false,

    evidencia: []

}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DOCUMENTOS:
            return {
                ...state,
                load_doc: true,
                error_doc: ''
            }
        case LISTA_DOCUMENTOS:
            return {
                ...state,
                load_doc: true,
                documentos: [],
                paginate: {
                    total: 0,
                    perPage: 5,
                    page: 1,
                    lastPage: 1
                },
                documento: undefined,
                error_doc: '' 
            }
        case DOCUMENTOS_SUCCESS:
            return {
                ...state,
                load_doc: false,
                documentos: action.payload.documentos,
                paginate: action.payload.paginate,
                error_doc: ''
            }
        case DOCUMENTOS_FAIL:
            return {
                ...state,
                load_doc: false,
                error_doc: action.payload
            }
        case DOCUMENTO_ADICIONADO:
            return {
                ...state,
                load_doc: false,
                documento: action.payload,
                error_doc: ''
            }
        case DOCUMENTO_ADICIONADO_FAIL:
            return {
                ...state,
                load_doc: false,
                error_doc: action.payload
            }
        case SIG:
            return {
                ...state,
                sig_msg: '',
                sig_load: true,
            }
        case SIG_SUCCESS:
            return {
                ...state,
                sig_msg: action.payload,
                sig_load: false,
            }
        case SIG_FAIL:
            return {
                ...state,
                sig_msg: action.payload,
                sig_load: false,
                sig_error: true
            }
        case DOC_SELECTED: 
            return {
                ...state,
                documento: action.payload
            }
        case DOC_NOT_SELECTED:
            return {
                ...state,
                documento: undefined
            }
        case SIG_CONTATAR_SUCCESS:{
            return {
                ...state,
                sig_load: false,
                sig_contatar_msg: action.payload
            }
        }
        case SIG_CONTATAR_FAIL:{
            return {
                ...state,
                sig_load: false,
                sig_contatar_msg: action.payload
            }
        }
        case SIG_REMOVE:
            return {
                ...state,
                sig_load: !state.sig_load,
                sig_remove_msg: action.payload
            }
        case EXIBIR_DOC: 
            return {
                ...state,
                exibir_doc_load: true,
                exibir_doc: undefined
            }
        case EXIBIR_DOC_SUCCESS: 
            return {
                ...state,
                exibir_doc: action.payload,
                exibir_doc_load: false,
            }
        case EXIBIR_DOC_FAIL: 
            return {
                ...state,
                exibir_doc: undefined,
                exibir_doc_load: false,
            }
        case BAIXAR_DOC:
            return {
                ...state,
                load_doc: false,
                error_doc: action.payload
            }
        case CHANGE_STATUS: 
            return {
                ...state,
                load_change_status: true,
                change_status_msg:'',
                change_status_error: false 
            }
        case CHANGE_STATUS_SUCCESS:
            return {
                ...state,
                load_change_status: false,
                change_status_msg: action.message,
                change_status_error: false ,
                documento: {
                    ...state.documento,
                    ...action.payload,
                },
            }
        case CHANGE_STATUS_FAIL: 
            return {
                ...state,
                load_change_status: false,
                change_status_msg: action.payload,
                change_status_error: true 
            }
        case LIMPA_MSGS: 
            return {
                ...state,
                change_status_msg: '',
                sig_msg: '',
                error_doc: ''
            }
        case EXIBIR_EVIDENCIA:
            return {
                ...state,
                exibir_doc_load: true,
                evidencia: undefined
            }
        case EXIBIR_EVIDENCIA_SUCCESS: 
            return {
                ...state,
                evidencia: action.payload,
                exibir_doc_load: false,
            }
        case EXIBIR_EVIDENCIA_FAIL: 
            return {
                ...state,
                evidencia: [],
                exibir_doc_load: false,
            }
        case AGRUPADOR:
            return { ...state, ...action.payload, load_doc: false }
        case ADDSTATE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}